(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Onboarding", [], factory);
	else if(typeof exports === 'object')
		exports["Onboarding"] = factory();
	else
		root["Onboarding"] = factory();
})(this, function() {
return 